import { render } from "./PhoneSvg.vue?vue&type=template&id=1e29a6ee"
import script from "./PhoneSvg.vue?vue&type=script&lang=js"
export * from "./PhoneSvg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__